import { UserBasicInfo } from "hoksource";

export function UserBasicInfoName(userBasicInfo:UserBasicInfo)
{
    return (userBasicInfo?.lastName ? userBasicInfo?.lastName + ", " : "") + (userBasicInfo?.firstName ?? "");

}